<h3>All</h3>
@if (state === 'ready') {
  <div class="tutorials">
    @for (tutorial of tutorials; let index = $index; track tutorial.id) {
      <app-tutorial
        [tutorial]="tutorial"
        [beingDownloaded]="tutorialsBeingDownloaded.includes(index)"
        (clicked)="onTutorialClick(tutorial, index)"></app-tutorial>
    } @empty {
      <span class="empty">No tutorials found</span>
    }
  </div>
} @else {
  <app-tutorial-skeleton [numberOfSkeletons]="4"></app-tutorial-skeleton>
}
